export enum DepartmentFilterType {
  Department = "Department",
  NoDepartment = "NoDepartment",
  AllDepartments = "AllDepartments",
}
